// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3ZG-a","name":"ConsentHeader_name__1isJH","birthday":"ConsentHeader_birthday__3Pm6A","skeleton":"ConsentHeader_skeleton__1jGAG"};